import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import Add from "./Add";
import Edit from "./Edit";

const baseURL = process.env.REACT_APP_API_JOBS;

const MyonMakdeem = ({ visible, mekhraz_id }) => {
  const [myon, setMyon] = useState({});
  const [isAdded, SetIsAdded] = useState(false);
  const [loading, setLoading] = useState(true);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "myonmakdeem?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          }
        );
        isMounted && setMyon(response.data[0]);
        setLoading(false);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, [isAdded]);

  if (!visible) return;

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    if (myon) {
      return <Edit myon={myon} setMyon={setMyon} />;
    } else {
      return <Add mekhraz_id={mekhraz_id} SetIsAdded={SetIsAdded} />;
    }
  }
};

export default MyonMakdeem;
